module.exports = __webpack_public_path__ + "img/Cypress.43e95980.svg";